module.exports = __webpack_public_path__ + "static/60-days-guarantee-a041e23634238d8bb2b9ebdd112712ed.svg";